import {FC} from 'react';
import {Controller} from 'react-hook-form';
import * as React from 'react';
import {HookFormProps} from './HookFormProps';
import {
	ChoiceGroupCompat as ChoiceGroup,
	DirectionalHint,
	IChoiceGroupProps,
} from 'components/FluentUICompat';

type ControlledChoiceGroupProps = Omit<IChoiceGroupProps, 'defaultValue'> &
	HookFormProps & {
		getSelectedKey: (value: any) => string;
		getValue: (selection: {key: string; text: string} | undefined) => any;
	};

export const ControlledChoiceGroup: FC<ControlledChoiceGroupProps> = props => {
	return (
		<Controller
			name={props.name}
			control={props.control}
			rules={props.rules}
			defaultValue={props.getValue(undefined)}
			render={({field: {onChange, value}}) => {
				return (
					<ChoiceGroup
						{...props}
						onChange={(e, selection) => {
							onChange(props.getValue(selection));
						}}
						selectedKey={props.getSelectedKey(value)}
					/>
				);
			}}
		/>
	);
};
